// $(document).ready(function () {
//   var mainSection = $('.p-mainSection');
//   var logo = $('.l-header__logo img');
//   var logoDefault = logo.attr('src');
//   var logoWh = logoDefault.replace('logo.svg', 'logo-wh.svg');

//   var hasDataHeaderWh = $('.l-header').attr('data-header-wh') !== undefined;

//   function updateHeader() {
//     var currentPosition = $(window).scrollTop();
//     var mainSectionPosition = mainSection.offset().top;

//     if (currentPosition > mainSectionPosition) {
//       $('.l-header').removeAttr('data-header-wh');
//       logo.attr('src', logoDefault);
//     } else {
//       $('.l-header').attr('data-header-wh', '');
//       logo.attr('src', logoWh);
//     }
//   }

//   if (hasDataHeaderWh) {
//     updateHeader();
//     $(window).on('scroll', updateHeader);
//   }
// });

$(document).ready(function () {
  var mainSection = $('.p-mainSection');
  var logo = $('.l-header__logo img');
  var logoDefault = logo.attr('src').replace('logo-wh.png', 'logo.png');
  var logoWh = logo.attr('src').replace('logo.png', 'logo-wh.png');

  var header = $('.l-header');
  var hasDataHeaderWh = header.attr('data-header-wh') !== undefined;

  function updateHeader() {
    var currentPosition = $(window).scrollTop();
    var mainSectionPosition = mainSection.offset().top;

    if (currentPosition > mainSectionPosition) {
      header.removeAttr('data-header-wh');
      logo.attr('src', logoDefault);
    } else {
      header.attr('data-header-wh', '');
      logo.attr('src', logoWh);
    }
  }

  if (hasDataHeaderWh) {
    $(window).on('scroll', updateHeader);
  }
});